import { createStyles } from '@material-ui/styles';
import { makeStyles, Typography, Theme } from '@material-ui/core';
import React, { FC } from 'react';

import { MobileViewDefinition } from '../services/layout';
import { FormControlProps, useImplicitVisibility } from '../utils';
import { registry } from '../registry';
import { TemplatedText, TemplatedTextProps } from './TemplatedText';
import { LayoutNodeWrapper } from './LayoutNode';

export interface ViewProps extends FormControlProps<MobileViewDefinition> {
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    root: {
      flex: 1,
      marginBottom: theme.spacing(1)
    },
    header: {
      alignContent: 'center',
      marginBottom: theme.spacing(1)
    },
    title: {
      height: '100%'
    },
    contents(props: any) {
    const direction = props?.definition?.style?.direction === 'row'
      ? 'row'
      : 'column';

    return {
      paddingTop: 0,
      flex: 1,
      display: 'flex',
      flexDirection: direction,
      [theme.breakpoints.up('md')]: {
        alignItems: direction === 'row' ? props.definition.style.align ? props.definition.style.align : '' : ''
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: direction === 'row' && props?.definition?.style?.condensedBehavior === 'preserve'
          ? 'row'
          : 'column'
        }
      }
    },
    child(_: any) {
    return {
      flex: 1,
      display: 'flex'
    }
    }
  })
});

export const View: FC<ViewProps> = function(props) {
  const { definition, path } = props;
  const classes = useStyles(props);
  const isVisible = useImplicitVisibility(definition);
  const styles = definition?.styles ? definition?.styles : {};

  // need some interpolation here
  return (
    isVisible
    ? (
      <div className = { classes.root } style = {styles}>
        {
          definition.title && <div className = { classes.header }>
            {
              typeof definition.title === 'string'
                ? (
                    <Typography
                      align = { 'left' }
                      variant = { 'body1' }
                      className = { classes.title }>
                      { definition.title }
                    </Typography>
                  )
                : <TemplatedText { ...definition.title as TemplatedTextProps }></TemplatedText>
            }
          </div>
        }
        <div className = { classes.contents }>
          {
            definition.children.map((_, key) => {
              return <LayoutNodeWrapper
                  path = { path.concat('/children/') + key }
                  key = { key }>
                  </LayoutNodeWrapper>
              })
          }
        </div>
      </div>
      )
    : null
  )
};

registry.registerComponent('View', View);
